import {z} from 'zod';

export default z.object({
    embed: z.string(),
    service: z.string(),
    height: z.number().optional(),
    width: z.number().optional(),
    // real rendered twitframe height captured in the admin editor (index.js),
    // used by View.svelte to reserve exact space on SSR for twitter/x
    measured_height: z.number().optional(),
});
